import { inject, InjectionToken } from '@angular/core';
import {
  combineLatest,
  debounceTime,
  map,
  ReplaySubject,
  share,
  shareReplay,
  startWith,
  switchMap,
} from 'rxjs';
import { EventsService } from './services/events.service';
import { AuthService } from '@rezevent/core';
import { VenueService } from './services/venue.service';
import { MenuService } from './services/menu.service';

export const APP_BASE = new InjectionToken<AppBase>('APPBASE_TOKEN');

export abstract class AppBase {
  private _eventService = inject(EventsService);
  private _auth = inject(AuthService);
  private venueService = inject(VenueService);
  private menuService = inject(MenuService);

  currentMonthOnCalendar$ = new ReplaySubject<number>(1);

  logout(): void {
    this._auth.logout();
  }

  reservations$ = this.currentMonthOnCalendar$.pipe(
    startWith(new Date().getMonth() + 1),
    debounceTime(700),
    switchMap(month => this._eventService.fetch$(month)),
    share()
  );

  allVenues$ = combineLatest([
    this.venueService.list$.pipe(shareReplay(1)),
    this.venueService.refresh$.pipe(startWith(null)),
  ]).pipe(
    map(([list]) => list),
    share()
  );

  menuOptions$ = combineLatest([
    this.menuService.list$,
    this.menuService.refresh$.pipe(startWith(null)),
  ]).pipe(
    map(([list]) => list),
    share()
  );
}
